import styled from 'styled-components';
import { colors } from '../../Utils/tokens';

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 6px;
  height: 48px;
  padding: 12px;
  background-color: ${colors.surfaceContainer};
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const HeaderTitle = styled.span`
  flex: 1 0 0;
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: ${colors.onSurface};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
`;
